<template>
    <div class="visitRecord">
        <div class="query-content">

            <el-form :model="queryformdata" :inline="true" style="margin-bottom: 20px;">
                <el-form-item label="楼栋" style="margin-right: 8px;">
                    <el-select v-model="queryformdata.houseId" placeholder="请选择楼栋" style="width:150px;" :disabled="HouseByManagerUserCombobox.length < 2" @change="builidingTreeComboHandleClick">
                        <el-option v-for="item in HouseByManagerUserCombobox" :key="item.houseId" :label="item.houseName" :value="item.houseId">
                        </el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label="日期" style="margin-right: 8px;">
                    <el-date-picker ref="startTime" :clearable="false" v-model="queryformdata.startTime" type="date" value-format="yyyy-MM-dd" @change="startDateChange" style="width: 140px">
                    </el-date-picker>

                </el-form-item>
                <el-form-item label="-">
                    <el-date-picker ref="endTime" :clearable="false" v-model="queryformdata.endTime" type="date" value-format="yyyy-MM-dd" :picker-options="endtimepickerOptions" style="width: 140px">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-input class="input" placeholder="请输入受访人、受访宿舍查询" v-model="queryformdata.nameOrDormitory">
                        <el-button slot="append" icon="el-icon-search" @click="loadDataInFirstPage">查询</el-button>
                    </el-input>
                </el-form-item>
                <el-button class="reset-btn" @click="reset">重置</el-button>

                <div style="float: right;margin-right: 20px">
                    <el-button type="primary" class="export-btn el-icon-download" @click="exportExl">导出记录</el-button>
                    <el-button class="sign-btn" @click="showAddVisitForm=true">登记</el-button>

                </div>
            </el-form>

        </div>
        <div class="tableList">
            <template>
                <el-table border stripe :data="dataList" header-row-class-name="table-header" style="width: 1200px;">

                    <el-table-column type="index" label="序号" width="50" align="center">
                    </el-table-column>
                    <el-table-column prop="visitTime" label="时间" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="name" label="来访人员" width="150" align="center">

                    </el-table-column>
                    <el-table-column prop="idNum" label="身份证号" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="phoneNum" label="手机号码" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="remark" label="来访事宜" width="200" align="center">

                    </el-table-column>
                    <el-table-column prop="receptionName" label="受访人" width="109" align="center">
                    </el-table-column>
                    <el-table-column prop="receptionDormitory" label="受访宿舍" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="id" label="操作" width="100" align="center">
                        <template slot-scope="scope">
                            <span class="operate" @click="visitRecordDetail(scope.row)">查看</span>
                            <span class="operate" @click="deleteRecord(scope.row.id)">删除</span>
                        </template>
                    </el-table-column>

                </el-table>
            </template>
            <div class="pagination-container ">
                <v-pagination @pageChange="onCurrentChange" :total="total" :isShow="showPagination" :page="page"></v-pagination>
            </div>
        </div>
        <!--新增来访人员 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="添加来访人员" :visible.sync="showAddVisitForm" width="777px" left class="visitPeopleForm" @close="cancelVisitRecordForm">
            <div class="warning-wrapper">
                <span class="el-icon-warning warning"></span>
                带
                <span class="red">*</span>号的为必填项
            </div>
            <el-form ref="visitRecordForm" :model="visitRecordForm" :rules="visitRecordFormRules">

                <el-col :span="8" style="padding-right:20px">
                    <div class="img-list">
                        <img v-show="visitRecordForm.image" :src="visitRecordForm.image">
                        <div>来访人照片</div>
                        <div>(已安装身份证阅读器的学校可刷身份证自动读取)</div>
                    </div>
                </el-col>
                <el-col :span="16">
                    <el-col :span="12">
                        <el-form-item label="姓名:" prop="name">
                            <el-input v-model="visitRecordForm.name" maxlength="20" placeholder="最多20字符数" v-inputexclude="'\\s+'"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="受访人:" prop="receptPeopel">
                            <el-input v-model="visitRecordForm.receptPeopel" maxlength="20" placeholder="最多20字符数" v-inputexclude="'\\s+'"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="身份证号:" prop="idNum">
                            <el-input v-model="visitRecordForm.idNum" maxlength="20" placeholder="限数字，最多20字" v-inputexclude="'\\s+'"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="受访宿舍:" prop="room">
                            <el-input v-model="visitRecordForm.room" maxlength="20" placeholder="最多20字符数" v-inputexclude="'\\s+'"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号码:" prop="phoneNum">
                            <el-input v-model="visitRecordForm.phoneNum" maxlength="20" placeholder="限数字，最多20字" v-inputexclude="'\\s+'"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="来访时间:" prop="datetime">
                            <el-date-picker v-model="visitRecordForm.datetime" type="datetime" placeholder="选择日期时间" format="yyyy-MM-dd HH:mm:ss" :default-value="new Date()" value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="来访事宜:" prop="remark">
                            <el-input type="textarea" v-model="visitRecordForm.remark" style="width: 100%;" placeholder="最多输入50字符" maxlength="50"></el-input>
                        </el-form-item>
                    </el-col>
                </el-col>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="comfirmVisitRecordForm">确定</el-button>
                <el-button @click="cancelVisitRecordForm()">取消</el-button>
            </span>
        </el-dialog>
        <!--查看来访人员信息 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="查看来访人员信息" :visible.sync="showVisitRecordDetail" width="877px" left class="visitRecordDetail">
            <el-col :span="8" style="padding-right:20px">
                <div class="img-box">
                    <img v-show="currentRecord.image" :src="currentRecord.image">
                </div>
            </el-col>
            <el-col :span="16">
                <el-col :span="12">
                    <div class="line">
                        <span class="label">姓名:</span>
                        <span class="text">{{currentRecord.name}}</span>
                    </div>

                </el-col>
                <el-col :span="12">
                    <div class="line">
                        <span class="label">受访人:</span>
                        <span class="text">{{currentRecord.receptionName}}</span>
                    </div>

                </el-col>
                <el-col :span="12">
                    <div class="line">
                        <span class="label">身份证号:</span>
                        <span class="text">{{currentRecord.idNum}}</span>
                    </div>

                </el-col>
                <el-col :span="12">
                    <div class="line">
                        <span class="label">受访宿舍:</span>
                        <span class="text">{{currentRecord.receptionDormitory}}</span>
                    </div>

                </el-col>
                <el-col :span="12">
                    <div class="line">
                        <span class="label">手机号码:</span>
                        <span class="text">{{currentRecord.phoneNum}}</span>
                    </div>

                </el-col>
                <el-col :span="12">
                    <div class="line">
                        <span class="label">来访时间:</span>
                        <span class="text">{{currentRecord.visitTime}}</span>
                    </div>

                </el-col>
                <el-col :span="24">
                    <div class="line">
                        <span class="label">来访事宜:</span>
                        <span class="text">{{currentRecord.remark}}</span>
                    </div>
                </el-col>
            </el-col>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="showVisitRecordDetail = false">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '@/api';
import basetable from '@/mixins/base-table';
import vRules from '@/config/validate_rules';
import { dateTimeFormatter } from '@/components/calendar/tools.js'

export default {
    components: {
    },
    props: {},
    mixins: [basetable],
    data () {
        let vm = this;
        return {
            doNotInit: true,
            vRules,
            queryformdata: {
                startTime: '',
                endTime: '',
                nameOrDormitory: '',
                houseId: '',
                schoolNum: ''
            },
            endtimepickerOptions: {
                disabledDate (time) {
                    if (vm.queryformdata.startTime) {
                        return time < new Date(vm.queryformdata.startTime + ' 00:00:00').getTime();
                    }
                    return false;
                },
            },
            showAddVisitForm: false,
            visitRecordForm: {
                name: '',
                receptPeopel: '',
                idNum: '',
                room: '',
                phoneNum: '',
                datetime: dateTimeFormatter(new Date(), 'yyyy-MM-dd hh:mm:ss'),
                remark: '',
                image: ''
            },
            visitRecordFormRules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }, vRules.illegalCharacter],
                receptPeopel: [vRules.illegalCharacter],
                idNum: [{ required: true, message: '请输入身份证号码', trigger: 'blur' }, vRules.idPattern],
                room: [vRules.illegalCharacter],
                phoneNum: vRules.mobilePhone,
                datetime: [{ required: true, message: '请选择来访时间', trigger: 'blur' }],
                remark: [{ required: true, message: '请输入来访事宜', trigger: 'blur' }]
            },
            showVisitRecordDetail: false,
            currentRecord: {},
            HouseByManagerUserCombobox: [], // 宿管员楼栋下拉

        }
    },
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ]),

    },
    methods: {
        queryHouseByManagerUser () {
            return api.summary.queryHouseByManagerUser().then(res => {
                if (res.code == 0) {
                    this.HouseByManagerUserCombobox = res.data;
                } else {
                    this.$message(res.message);
                }
                return res.data;
            });
        },
        builidingTreeComboHandleClick (item) {
            let list = this.HouseByManagerUserCombobox.filter( x => x.houseId === item);
            this.queryformdata.schoolNum = list[0].schoolNum;
        },
        visitRecordDetail (row) {
            this.currentRecord = row;
            this.showVisitRecordDetail = true;
        },
        deleteRecord (id) {
            let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-success" style="color: #FD8C25;font-size: 50px;"></span> </div>
							<p>确认删除该条记录吗？</p>
                        </div>`;

            this.$alert(html, "确认删除?", {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确定删除",
                showCancelButton: true
            }).then(_ => {
                api.accessManage.delVisit(id).then((res) => {
                    if (res.code == 0) {
                        this.loadData();
                    } else {
                        this.$message(res.message);
                    }
                })
            }).catch((e) => { console.log(e) })

        },
        startDateChange (v) {
            this.queryformdata.endTime = v;
        },
        scoreROW (score) {
            if (score > 3) {
                return {
                    class: 'green',
                    text: '优秀'
                }
            }
            if (score === 3) {
                return {
                    class: 'orange',
                    text: '合格'
                }
            } else {
                return {
                    class: 'red',
                    text: '不合格'
                }
            }
        },
        // 返回当天年月日
        _setCurrentTime () {
            let date = new Date();
            let year = date.getFullYear();
            let month = this._padZero(date.getMonth() + 1);
            let day = this._padZero(date.getDate());
            return [year, month, day].join("-");
        },
        _padZero (str) {
            let start = str.length == 2 ? 0 : 1;
            return ("0" + str).substring(start);
        },
        loadData () {
            if (this.queryformdata.startTime === '' && this.queryformdata.endTime) {
                this.$message('请选择开始时间!');
                return;
            }
            if (this.queryformdata.endTime === '' && this.queryformdata.startTime) {
                this.$message('请选择结束时间!');
                return;
            }
            let param = {
                startTime: this.queryformdata.startTime || undefined,
                endTime: this.queryformdata.endTime || undefined,
                nameOrDormitory: this.queryformdata.nameOrDormitory || undefined,
                houseId: this.queryformdata.houseId + ''
            };
            api.accessManage.getVisitList(param, this.page, this.size).then((res) => {
                if (res.code == 0) {
                    let data = res.data;
                    this.total = data.total;
                    this.dataList = data.list;
                } else {
                    this.$message(res.message);
                }
            });
        },
        loadDataInFirstPage () {
            this.page === 1 ? this.loadData() : this.page = 1;
        },
        reset () {
            this.queryformdata = {
                startTime: this._setCurrentTime(),
                endTime: this._setCurrentTime(),
                nameOrDormitory: '',
                houseId: this.HouseByManagerUserCombobox.length > 0 ? this.HouseByManagerUserCombobox[0].houseId : '',
                schoolNum: this.HouseByManagerUserCombobox.length > 0 ? this.HouseByManagerUserCombobox[0].schoolNum : ''
            };
        },
        exportExl () {
            if (this.queryformdata.startTime === '' && this.queryformdata.endTime) {
                this.$message('请选择开始时间!');
                return;
            }
            if (this.queryformdata.endTime === '' && this.queryformdata.startTime) {
                this.$message('请选择结束时间!');
                return;
            }
            let param = {
                startTime: this.queryformdata.startTime || undefined,
                endTime: this.queryformdata.endTime || undefined,
                nameOrDormitory: this.queryformdata.nameOrDormitory || undefined,
                houseId: this.queryformdata.houseId + ''
            };
            api.accessManage.exportVisitList(param, this.page, this.size).then((res) => {
                var key, value;
                [key, value] = Object.entries(res.data)[0];
                this.$common.globalExportExl(key, value, '来访人员记录');
            })
        },
        addVisitRecord () {

            this.showAddVisitForm = true;
        },
        comfirmVisitRecordForm () {
            this.$refs.visitRecordForm.validate((valid) => {
                if (valid) {
                    let param = {
                        idNum: this.visitRecordForm.idNum,
                        image: this.visitRecordForm.image || undefined,
                        name: this.visitRecordForm.name,
                        phoneNum: this.visitRecordForm.phoneNum,
                        receptionDormitory: this.visitRecordForm.room || undefined,
                        receptionName: this.visitRecordForm.receptPeopel || undefined,
                        remark: this.visitRecordForm.remark,
                        visitTime: this.visitRecordForm.datetime || undefined,
                        houseId: this.queryformdata.houseId,
                        schoolNum: this.queryformdata.schoolNum
                    }
                    api.accessManage.addVisit(param).then((res) => {
                        if (res.code === 0) {
                            this.cancelVisitRecordForm();
                            this.loadData();
                        } else {
                            this.$message(res.message);
                        }
                    })
                }
            })
        },
        cancelVisitRecordForm (done) {
            this.showAddVisitForm = false;
            this.$refs.visitRecordForm.resetFields();
            this.visitRecordForm = {
            	name: '',
                receptPeopel: '',
                idNum: '',
                room: '',
                phoneNum: '',
                datetime: dateTimeFormatter(new Date(), 'yyyy-MM-dd hh:mm:ss'),
                remark: '',
                image: ''
            }
            done && done();
        }

    },
    created () {
        this.queryformdata.startTime = this._setCurrentTime();
        this.queryformdata.endTime = this._setCurrentTime();
        this.queryHouseByManagerUser().then((data) => {
            if (data && data.length > 0) {
                this.queryformdata.houseId = data && data[0].houseId;
                this.queryformdata.schoolNum = data && data[0].schoolNum;
            }

            this.loadData();
        })
    },
    mounted () {
    }
}
</script>
<style lang="scss" >
.visitRecord {
  padding: 20px 0;
  .warning-wrapper {
    margin-bottom: 24px;
    line-height: 20px;
  }
  .warning {
    color: #e6a23c;
  }
  .input {
    width: 280px;
    float: right;
    margin-top: 5px;
    .el-input__inner {
      border: 1px solid #26aef3;
      border-right: none;
      width: 220px;
    }
    .el-input-group__append {
      border: 1px solid #26aef3;
      border-left: none;
      background-color: #26aef3;
      color: #fff;
    }
  }
  .reset-btn {
    margin-top: 5px;
  }
  .sign-btn {
    width: 60px;
    height: 30px;
    background-color: #ffb324;
    border-color: #ffb324;
    color: #fff;
    margin-top: 5px;
  }
  .export-btn {
    margin-top: 5px;
    border: 1px solid #26aef3;
    color: #26aef3;
    background-color: #fff;
  }
  .visitPeopleForm {
    textarea {
      height: 100px;
    }
    .el-form-item__label {
      line-height: 20px;
    }
    .img-list {
      position: relative;
      text-align: center;
      height: 335px;
      padding-top: 145px;
      border: 1px solid #dbdbdb;
      div {
        color: #4d4d4d;
        margin-bottom: 20px;
      }
      img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
      }
    }
  }
  .visitRecordDetail {
    .img-box {
      position: relative;
      text-align: center;
      height: 335px;
      border: 1px solid #dbdbdb;
      img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
      }
    }
    .line {
      display: flex;
      width: 100%;
      line-height: 40px;
      margin-bottom: 25px;
      .label {
        min-width: 80px;
        color: #666;
        font-weight: bolder;
      }
      .text {
        flex-grow: 1;
      }
    }
  }
  .operate {
    color: #26aef3;
    cursor: pointer;
  }
  .red {
    color: red;
  }
  .el-form-item {
    margin-bottom: 18px;
    margin-right: 20px;
  }
  .query-content {
    margin-bottom: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/accessManage/visitRecord.vue